import { Configurator } from "./configurator";
import { Bitrix } from "./bitrix";

export const API = {
    Bitrix: Bitrix,
    Configurator: Configurator,
};
